import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import {AppComponent} from '../../app.component';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { element } from 'protractor';
import { AlertService } from '../../alertpopup/_alert';
export interface FilterData {
  filter: string;
  AdvanceSearch: any;
}

@Component({
    selector: 'app-report-config-nav',
    templateUrl: './report-config-nav.component.html',
    styleUrls: ['./report-config-nav.component.css'],
    standalone: false
})
export class ReportConfigNavComponent implements OnInit {
  master: any;
  url: string;
  pageurl: string;
  TypeHeader: string;
  MsgType: number;
  pageNumber: number;
  DisplayMessage: string;
  FormSearchReportConfigForm: FormGroup;
  advanceSearchValue: any;
  modalURL: any;
  ModelFor: string;
  CallFunctionOnCloseModal: any;
  RequestFrom: string;
  selectedAll: any;
  isSelected: boolean[];
  RightsID: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.RightsID = localStorage.getItem('UserRight');
    this.isSelected = [];
    this.pageNumber = 1;
    this.MsgType = 1; // Loading
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.advanceSearchValue = "";
    this.FetchReportConfig( '');

      if (this.RightsID.includes('202018001') || this.RightsID.includes('202018021') || this.RightsID.includes('202018000')) {
      } else {
        window.location.href="module/0";
      }

    this.FormSearchReportConfigForm = this.formBuilder.group({
      txtSearch: ['']
    });
  }
  OpenModal(url, cID, modelName, urld)    {
    this.CallFunctionOnCloseModal = urld;
    this.ModelFor = modelName;
    if (modelName == "Filter") {
      window.addEventListener("message", this.receiveMessage, false);

        this.modalURL = "filter/202018000" ;

    }
  }
  receiveMessage(event) {//
    if (event.data.data.Param != null) {
      localStorage.setItem('advancesearch', event.data.data.Param);
      let element: HTMLElement;
      element = document.getElementsByClassName('close')[0] as HTMLElement;
      element.click();
    }
  }
  ReturnAdvanceSearch() {
    if (localStorage.getItem('advancesearch') != "") {
      this.advanceSearchValue = JSON.parse(localStorage.getItem('advancesearch')); }
    localStorage.setItem('advancesearch', "");
    this.FetchReportConfig( '');
  }
  DeleteRecord(ID){
    if (confirm('Are you sure to delete it ?')) {
      this.http.get(this.url + 'Report/Delete_ReportConfig?ID=' + ID)
    .subscribe( (data) =>   {
      this.alertService.success(data.toString() , this.options);
         this.FetchReportConfig('');

       }
    );
    }

  }
  onSearchReportConfig(SearchData) {
    this.FetchReportConfig( SearchData.txtSearch);
  }
  selectAll(page, ischeck) {
    for (let i = 0; i < this.master.length; i++) {
      this.isSelected[i] = false;
  }

  // select all on current page
    for (let i = 2 * (page - 1) + 1; i < 2 * ( page - 1 ) + 2 + 1; i++) {
      if (i <= this.master.length - 1) {
          this.isSelected[i] = ischeck.target.checked;
      }
  }
  }

  FetchReportConfig( filter) {
    let filterData: FilterData = {
      filter: filter,
      AdvanceSearch: this.advanceSearchValue
     };
    this.http.post(this.url + 'Report/FetchReportConfigRecord', filterData)
    .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {
          this.MsgType = 2; // No Data Found
          this.DisplayMessage = "No Data Found";
          this.master = '';
        } else {
          this.MsgType = 0; // No Message
          this.master = JSON.parse(data.toString());
        }
      },
      (error) => {
         this.MsgType = 3; // Error Message
         this.DisplayMessage = error.message;
       }
    );
  }
}
